import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    container:
      'flex w-full flex-col gap-6 lg:flex-row lg:items-center lg:justify-between',
    ratingBlock: 'flex flex-col gap-2 max-sm:mt-4 max-sm:mb-6'
  }
});
